import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Camino a la Luz';
render(<App data-id="element-273" />, document.getElementById('root'));